import { render } from "./ProfileTab.vue?vue&type=template&id=3c03e203&scoped=true"
import script from "./ProfileTab.vue?vue&type=script&lang=js"
export * from "./ProfileTab.vue?vue&type=script&lang=js"

import "./ProfileTab.vue?vue&type=style&index=0&id=3c03e203&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c03e203"]])

export default __exports__